import translations from 'src/internationalisation/translation-map.json';

export const companySettings = [
  { id: 'currency', name: translations.currency },
  { id: 'sectionsDataStructure', name: translations.dataStructure },
  { id: 'hierarchy', name: translations.hierarchy },
  {
    id: 'hierarchyPermissions',
    name: translations.settings_hierarchyPermissions,
    level: 1,
    parent: 'hierarchy',
  },
  {
    id: 'hierarchyOptionalParameters',
    name: translations.settings_hierarchyOptionalParameters,
    level: 1,
    parent: 'hierarchy',
  },
  { id: 'templates', name: translations.automationRulesets },
  { id: 'kpi', name: translations.kpis },
  { id: 'timeTracker', name: translations.timeTracker_timeTracker },
  { id: 'priceBook', name: translations.priceBook },
  { id: 'rigOperationTemplates', name: translations.rigOperationTemplates },
  { id: 'costCodes', name: translations.projects_costCodes },
  { id: 'costSetup', name: translations.projects_costSetup },
];
